export const languageElements = {
    items: {
        'alert-grid-layout-saved': {
            hu: 'A táblázat elrendezését elmentettem.',
            de: 'Tabellenlayout gespeichert',
            en: 'Table layout saved',
        },

        'modal-delete-title': {
            hu: 'Táblázat elrendezésének alaphelyzetbe állítása',
            de: 'Tabellenlayout zurücksetzen',
            en: 'Reset table layout',
        },

        'modal-delete-body': {
            hu: 'Állítsam alaphelyzetbe a táblázat elrendezését?',
            de: 'Tabellenlayout zurücksetzen?',
            en: 'Reset the table layout?',
        },

        'alert-saved-title': {
            hu: 'A táblázat elrendezését elmentettük',
            de: 'Layout gespeichert',
            en: 'Layout saved successfully',
        },

        'button-CANCEL': {
            hu: 'Mégsem',
            de: 'Abbrechen',
            en: 'Cancel',
        },

        'button-DELETE': {
            hu: 'Állítsd alaphelyzetbe',
            de: 'Tabellenlayout zurücksetzen',
            en: 'Reset table layout',
        },
    }
};
